/**
 * 热门列表
 */
import React, {Component} from 'react';
import Masonry from 'react-masonry-component';
import { ListItem  } from './item';
 
class Hots extends Component {
 	static defaultProps = {
 		list: []
 	}

 	render() {

 		return (
 			<div ref="wrap">
 				<Masonry
                        className={'video-list'} // default ''
                        elementType={'ul'} // default 'div'
                        disableImagesLoaded={false} // default false
                        updateOnEachImageLoad={true} // default false and works only if disableImagesLoaded is false
                    >
 				{
 					this.props.list.map((item, index)=>{
 						return <ListItem key={index} item={item}/>
 					})
 				}
 				</Masonry>
            </div>
 		);
 	}
 }

export default Hots;


// WEBPACK FOOTER //
// ./js/topic/hots.js